import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaterialModule } from '../../module/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedService } from '../../Services/shared.service';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [TablerIconsModule, MaterialModule, TranslateModule, CommonModule, FormsModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent {
  @Input() column!: any;
  @Input() list!: any[];
  @Input() OriginalList!: any[];
  @Output() newItemEvent = new EventEmitter<any>();

  constructor(private shared: SharedService) { }

  checkSearchVal(searchVal?:any) {
    let list = this.shared.checkSearchVal(this.list, this.OriginalList, searchVal, this.column);
    this.newItemEvent.emit({ list: list });
  }
}